export default __webpack_public_path__ + "static/media/ai_right_updated.ab945e5c.png";